// extracted by mini-css-extract-plugin
export default {"container":"main_page_container__WlTyh"};